import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon10pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9147 4.55756C11.8294 3.01097 10.0327 2 7.99985 2C4.68616 2 1.99988 4.68628 1.99988 7.99997C1.99988 11.3137 4.68616 13.9999 7.99985 13.9999C10.0331 13.9999 11.8301 12.9886 12.9153 11.4415C13.5866 10.5517 13.9999 9.33793 13.9999 7.99994C13.9999 6.66154 13.5863 5.44741 12.9147 4.55756ZM7.99985 12.7499C8.30489 12.7499 8.60322 12.7212 8.89227 12.6662C7.39373 11.9927 6.31873 10.1578 6.31873 7.99994C6.31873 5.84209 7.39369 4.00728 8.89218 3.33368C8.60316 3.27875 8.30486 3.25 7.99985 3.25C5.37651 3.25 3.24988 5.37663 3.24988 7.99997C3.24988 10.6233 5.37651 12.7499 7.99985 12.7499Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon10pm;
